import { api } from './client.js';

// 로그인 실패(401)는 「세션이 끊김」이 아니므로 전역 처리로 넘기지 않습니다.
export function signup({ email, password }) {
    return api('/auth/signup', { method: 'POST', body: { email, password }, skipAuthHandler: true });
}

export function login({ email, password }) {
    return api('/auth/login', { method: 'POST', body: { email, password }, skipAuthHandler: true });
}

export function logout() {
    return api('/auth/logout', { method: 'POST', skipAuthHandler: true });
}

export function fetchMe({ signal } = {}) {
    return api('/auth/me', { signal, skipAuthHandler: true });
}
